<template>
  <main id="album_wrap" class="flex flex-col items-center pt-20">
    <div class="header absolute w-full z-20 left-0 top-0 flex justify-between">
      <div class="ml-4 mt-4 w-10" @click="onOtherGalleries = !onOtherGalleries">
        <img
          class="icon"
          src="../../assets/images/gallery/group.png"
          alt="다른 사용자 가상전시관 보기"
        />
      </div>
      <div class="mt-2 w-16">
        <img class="logo" src="../../assets/images/logo-main.png" alt="로고" />
      </div>
      <div class="m-4">
        <button @click="onClose">
          <img
            src="../../assets/images/close_btn2.png"
            alt="close"
            class="w-6 m-auto"
          />
        </button>
      </div>
    </div>
    <ul v-if="!onOtherGalleries" class="grid grid-cols-2 gap-6 pb-20">
      <li
        v-for="(item, index) in relic.items"
        :key="index"
        class="w-32 h-32 rounded-xl flex justify-center items-center text-6xl"
        :class="{'none' : !item.getRelic}"
        @click="onLink(item)"
      >
        <img
          v-if="item.getRelic"
          :src="item.image"
          :alt="item.name"
          class="relic_img"
        />
        <img 
          v-else
          src="../../assets/images/album_box_none.png"
        />
      </li>
    </ul>
    <div class="relative w-full h-full" v-if="onOtherGalleries">
      <user-gallery-list />
    </div>
  </main>
</template>
<script>
import service from "../../services";
import UserGalleryList from "../../components/UserGalleryList.vue";
import { mapGetters } from "vuex";
export default {
  components: { UserGalleryList },
  data() {
    return {
      onOtherGalleries: false,
      relic: {
        items: [],
        totalItems: 0,
        totalPages: 0,
        page: 1,
        size: 1000,
      },
      userRelic: {
        items: [],
        totalItems: 0,
        totalPages: 0,
        page: 1,
        size: 1000,
      },
      usersId: 0,
    };
  },
  computed: {
    ...mapGetters(["getUserId"]),
  },
  beforeMount() {
    this.fetch();
  },
  mounted() {
    // this.getNextRelic();
  },
  methods: {
    async fetch() {
      await service.findMyInfoByToken().then(
        (response) => {
          const { data } = response;
          this.usersId = data.id;
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
          this.router.push({ name: "Login" });
        }
      );

      if (this.$route.params.relicId) {
        const regparams = {
          relicsId: this.$route.params.relicId,
        };
        await service.regUserRelics(regparams).then(
          (response) => {
            console.log(response);
            if (response.status == 200) {
              alert("도감에 저장되었습니다.");
            }
          },
          (error) => {
            const { data } = error.response;
            if (data.status == 409) {
              alert("이미 도감에 저장되었습니다.");
            }
          }
        );
      }
      const params = {
        page: this.relic.page,
        size: this.relic.size,
      };
      await service.relicFindAll(params).then(
        (response) => {
          const { data } = response;
          data.items.forEach((item) => {
            item.image = `${process.env.VUE_APP_BASE_API_URL}/api/files/load/${item.image}`;
          });
          let arUseItems = [];
          data.items.forEach((item) => {
            if (item.arUse == "Y") {
              arUseItems.push(item);
            }
          });
          this.relic.items = arUseItems;
          this.relic.totalItems = data.totalItems;
          this.relic.totalPages = data.totalPages;
        },
        (error) => {
          const { data } = error.response;
          console.log(data.message);
        }
      );
      await service
        .userRelicFindAll({
          usersId: this.usersId,
          page: this.userRelic.page,
          size: this.userRelic.size,
        })
        .then(
          (response) => {
            const { data } = response;
            this.userRelic.items = data.items;
            this.userRelic.totalItems = data.totalItems;
            this.userRelic.totalPages = data.totalPages;
          },
          (error) => {
            const { data } = error.response;
            console.log(data.message);
          }
        );
      this.relic.items.forEach((item) => {
        this.userRelic.items.forEach((userItem) => {
          if (item.id == userItem.relicsId) {
            item.getRelic = true;
          }
        });
      });
    },
    getNextRelic() {
      window.onscroll = async () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          if (this.relic.totalPages > this.relic.page) {
            const params = {
              page: (this.relic.page += 1),
              size: this.relic.size,
            };
            await service.relicFindAll(params).then(
              (response) => {
                const { data } = response;
                data.items.forEach((item) => {
                  this.relic.items.push(item);
                });
              },
              (error) => {
                const { data } = error.response;
                console.log(data.message);
              }
            );
          }
          if (this.userRelic.totalPages > this.userRelic.page) {
            await service
              .userRelicFindAll({
                page: (this.userRelic.page += 1),
                size: this.userRelic.size,
              })
              .then(
                (response) => {
                  const { data } = response;
                  data.items.forEach((item) => {
                    this.userRelic.items.push(item);
                  });
                },
                (error) => {
                  const { data } = error.response;
                  console.log(data.message);
                }
              );
          }
          this.relic.items.forEach((item) => {
            this.userRelic.items.forEach((userItem) => {
              if (item.id == userItem.relicsId) {
                item.getRelic = true;
              }
            });
          });
        }
      };
    },
    onLink(item) {
      if (item.getRelic) {
        this.$router.push({ name: "AlbumId", params: { id: item.id } });
      }
    },
    onClose() {
      this.$router.push({ name: "Antiquity", params: { reload: true } });
    },
  },
};
</script>

<style scoped>
#album_wrap {
  background: #fff;
  min-height: 100vh;
}

#album_wrap li {
  background: url("../../assets/images/album_box.png") no-repeat center;
}
#album_wrap li.none {
}
.relic_img {
  max-width: 70%;
  max-height: 70%;
}
</style>
